import { ChangeEvent, useRef } from 'react'

import { theme } from '@hhgtech/hhg-components'
import { Text } from 'components/atoms/text'
import { TextArea } from 'components/atoms/textarea'
import { StyledIconContainer } from 'components/molecules/iconContainer'
import { useIntl } from 'react-intl'

import { QuestionDataType } from './index'
import {
  StyledQuestionHeading,
  StyledQuestionTopContainer,
  StyledQuestionContent,
  StyledQuestionContainer,
  StyledQuestionWrapper,
} from './index.styled'

export type QuestionProps = {
  data: QuestionDataType
  index: number
  isLike?: boolean
  isOpen: boolean
  onOpenClick: () => void
  onInputValueChange: (e: ChangeEvent<HTMLTextAreaElement>) => void
}

const FeedbackQuestion = ({
  data,
  isOpen = false,
  onOpenClick,
  index,
  isLike,
  onInputValueChange,
}: QuestionProps) => {
  const { formatMessage: f } = useIntl()
  const translateTypeSelector = isLike ? 'like' : 'dislike'
  const questionRef = useRef<HTMLDivElement>(null)
  const title = f({
    id: `article.feedback.${translateTypeSelector}.${index}.title`,
  })
  const subText = f({
    id: `article.feedback.${translateTypeSelector}.${index}.subText`,
  })
  const warningText = f({
    id: `article.feedback.${translateTypeSelector}.${index}.warningText`,
  })

  return (
    <StyledQuestionContainer>
      <StyledQuestionTopContainer onClick={onOpenClick}>
        <StyledQuestionHeading>
          <StyledIconContainer
            size={24}
            iconSize={16}
            backgroundColor={data.iconBackgroundColor}
            className="question-icon"
          >
            <img loading="lazy" src={data.icon} alt="chevron" />
          </StyledIconContainer>
          <Text type="subtitle-2" className="question-title">
            {title}
          </Text>
        </StyledQuestionHeading>
        <div className="question-chevron" data-open={isOpen}>
          <img
            loading="lazy"
            src={isOpen ? '/icons/minus_line.svg' : '/icons/plus_line.svg'}
            style={{ width: 24, height: 24 }}
            alt=""
          />
        </div>
      </StyledQuestionTopContainer>
      <StyledQuestionContent
        style={
          isOpen
            ? {
                height: (questionRef.current?.clientHeight || 0) + 1,
              }
            : {}
        }
      >
        <StyledQuestionWrapper className="question-wrapper" ref={questionRef}>
          {/* <p className="question-subtext">{subText}</p> */}
          <TextArea
            value={data.value || ''}
            onChange={onInputValueChange}
            subTitle={subText}
            className="textarea-container"
          />
          <Text
            type="caption-2"
            color={theme.mbColors.midGray}
            className="question-warningtext"
          >
            {warningText}
          </Text>
        </StyledQuestionWrapper>
      </StyledQuestionContent>
    </StyledQuestionContainer>
  )
}

export { FeedbackQuestion }
